import {
  ShiftTemplatesService,
  type DeleteDayShiftTemplatesRequestAdmin,
  type DeleteShiftTemplatesRequestAdmin,
  type PostPutShiftTemplateRequestAdmin
} from '@/backend/market'
import { ShiftTemplateRepository } from '../../domain/repositories/ShiftTemplateRepository'
import { ShiftTemplateModel } from '../models/ShiftTemplateModel'
import { ShiftTemplateFilterModel } from '../models/ShiftTemplateFilterModel'
import type { ShiftTemplateFilterEntity } from '../../domain/entities/ShiftTemplateFilterEntity'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { CreateUpdateShiftTemplateEntity } from '../../domain/entities/CreateUpdateShiftTemplate'
import { CreateUpdateShiftTemplateModel } from '../models/CreateUpdateShiftTemplateModel'
import type { ShiftTemplateEntity } from '../../domain/entities/ShiftTemplateEntity'

export class ShiftTemplateRepositoryImpl implements ShiftTemplateRepository {
  async getShiftTemplates(
    filterData: ShiftTemplateFilterEntity
  ): Promise<PaginateEntity<ShiftTemplateModel[]> | { error: true }> {
    const shiftTemplateFilterModel = new ShiftTemplateFilterModel(filterData)
    try {
      const response = await ShiftTemplatesService.getShiftTemplatesAdmin(shiftTemplateFilterModel)
      const shiftTemplateModels = response.items?.map((item) => new ShiftTemplateModel(item))
      const result = new PaginateEntity<ShiftTemplateModel[]>(response, shiftTemplateModels)

      return result
    } catch {
      return { error: true }
    }
  }
  async getShiftTemplate(id: string): Promise<ShiftTemplateEntity | { error: true }> {
    try {
      const response = await ShiftTemplatesService.getShiftTemplateAdmin({
        id
      })
      const shiftTemplateModel = new ShiftTemplateModel(response)

      return shiftTemplateModel
    } catch {
      return { error: true }
    }
  }
  async createShiftTemplate(
    shiftTemplateData: CreateUpdateShiftTemplateEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateShiftTemplateModel = new CreateUpdateShiftTemplateModel(shiftTemplateData)
    try {
      await ShiftTemplatesService.postShiftTemplateAdmin({
        requestBody: createUpdateShiftTemplateModel as unknown as PostPutShiftTemplateRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateShiftTemplate(
    id: string,
    shiftTemplateData: CreateUpdateShiftTemplateEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateShiftTemplateModel = new CreateUpdateShiftTemplateModel(shiftTemplateData)
    try {
      await ShiftTemplatesService.putShiftTemplateAdmin({
        id,
        requestBody: createUpdateShiftTemplateModel as unknown as PostPutShiftTemplateRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteShiftTemplate(ids: string[]): Promise<{ success: true } | { error: true }> {
    try {
      await ShiftTemplatesService.deleteShiftTemplateAdmin({
        requestBody: { shiftTemplateIds: ids } as DeleteShiftTemplatesRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async deleteAllShiftTemplates(
    shiftDayOfWeek: string
  ): Promise<{ success: true } | { error: true }> {
    try {
      await ShiftTemplatesService.deleteDayShiftTemplateAdmin({
        requestBody: {
          shiftTemplateDayOfWeeks: [shiftDayOfWeek]
        } as DeleteDayShiftTemplatesRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
